import { Box, LinkBehavior, PrimaryButton, Typography } from "@crayon/design-system-react";
import AppRoutes from "routes/app-routes";

const MigrationCompletedStep = () => (
  <Box
    display="flex"
    flexDirection="column"
    justifyContent="center"
    alignItems="center"
    gap={1}
    mt={2}
  >
    <Typography variant="body1">Migration to Cloud-iQ is complete</Typography>
    <PrimaryButton
      component={LinkBehavior}
      href={AppRoutes.dashboard.route}
      testId="to-dashboard-button"
    >
      To dashboard
    </PrimaryButton>
  </Box>
);

export default MigrationCompletedStep;
